import application from 'application/application';

const controller = 'DefaultProcessesCreateController';

application

	.controller(controller, ['$rootScope', '$scope', '$state', '$stateParams', 'helper', '$http', 'API', 'permissions', 'ngNotify', ($rootScope, $scope, $state, $stateParams, helper, $http, API, permissions, ngNotify) => {

		$scope.processesPermissions = permissions.get('processes');
		$scope.loadingCreate = false;

		const

			defautEmptyProcess = {
				idUsuarioCliente: JSON.parse(localStorage.getItem('__authenticationUserData__')).idUsuarioCliente,
				processos: [
					{
						FlNumUnicaCNJ: true,
						fontesPesquisa: [{}]
					}
				]
			};

		$scope.emptyProcess = helper.cloneSimpleObject(defautEmptyProcess);
		$scope.uf = helper.responseStore();
		$scope.court = helper.responseStore();
		$scope.processFonts = helper.responseStore();
		$scope.processParameters = helper.responseStore();
		$scope.processFontsxParameters = helper.responseStore();
		$scope.processSituationProc = helper.responseStore();
		$scope.filters;

		$scope.recordUF = (responseStore) => {

			$http({
				...helper.http(API.federativeUnits, 'GET'),
				params: {
					ativo: true,
					campos: 'id,sigla',
					paginaAtual: 1,
					registrosPorPagina: -1
				}
			})
				.then(response => {

					responseStore.setItems(response.data.itens);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordUF($scope.uf);

		$scope.recordCourt = (process) => {
			if (process.tribunal)
				process.tribunal = '';

			if (process.instancia == -3)
				process.idUf = '';

			if (process.instancia != -3 && !process.idUf)
				return false;

			$http({
				...helper.http(API.judicialBranches, 'GET'),
				params: {
					...helper.httpFields([
						'id',
						'nome'
					]),
					ativo: true,
					idUF: process.idUf,
					idGrauJurisdicao: process.instancia,
					paginaAtual: $scope.court.getCurrentPage(),
					registrosPorPagina: 999999999
				}
			})
				.then(response => {

					$scope.court.setItems(response.data.itens);
				})

				.finally(() => $scope.court.setReady(true));
		};

		$scope.recordProcessFonts = (process) => {
			$http({
				...helper.http(API.processesFonts, 'GET'),
				params: {
					...helper.httpFields([
						'idOrgaoJudiciario',
						'nomeExibicaoFontePesquisa',
						'nomeExibicaoValorParamFontePesq',
						'valorParamFontePesq',
						'idFonteXTipoPesquisa'
					]),
					IdOrgaoJudiciario: process.idOrgaoJudiciario
				}
			})
				.then(response => {
					$scope.processFontsxParameters.setItems(response.data.itens);
					$scope.processFonts.setItems([...new Map(response.data.itens.map(item => [item['idFonteXTipoPesquisa'], item])).values()]);
				})

				.finally(() => $scope.processFonts.setReady(true));

		};

		$scope.recordProcessParameter = (font) => {
			$scope.processParameters.setItems(
				$scope.processFontsxParameters.getItems()
					.filter(obj => Object.keys(obj).includes('nomeExibicaoValorParamFontePesq') && obj.idFonteXTipoPesquisa == font)
			);

		};

		$scope.recordProcSituation = (responseStore) => {
			$http({
				...helper.http(API.searchProcClientUser, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens.filter(item => item.id == -1 || item.id == -7));
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordProcSituation($scope.processSituationProc);

		$scope.createProcess = (responseStore) => {

			$scope.loadingCreate = true;

			$http({
				...helper.http(API.processClients, 'POST'),
				data: {
					itens: [responseStore]
				}
			})
				.then(() => {
						ngNotify.set('Processo cadastrado com sucesso', {
							type: 'success',
							position: 'bottom'
						});

					$state.go('root.default.processes');
				});

		};

	}]);

export default controller;
